/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ScimAttributeMappingConfigurationResource } from './';
import {
    ScimAttributeMappingConfigurationResourceFromJSON,
    ScimAttributeMappingConfigurationResourceFromJSONTyped,
    ScimAttributeMappingConfigurationResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ScimAttributeMappingResource
 */
export interface ScimAttributeMappingResource {
    /**
     * 
     * @type {Array<ScimAttributeMappingConfigurationResource>}
     * @memberof ScimAttributeMappingResource
     */
    mappings: Array<ScimAttributeMappingConfigurationResource>;
}

/**
 * Check if a given object implements the ScimAttributeMappingResource interface.
 */
export function instanceOfScimAttributeMappingResource(value: object): value is ScimAttributeMappingResource {
    if (!('mappings' in value) || value['mappings'] === undefined) return false;
    return true;
}

export function ScimAttributeMappingResourceFromJSON(json: any): ScimAttributeMappingResource {
    return ScimAttributeMappingResourceFromJSONTyped(json, false);
}

export function ScimAttributeMappingResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScimAttributeMappingResource {
    if (json == null) {
        return json;
    }
    return {
        
        'mappings': ((json['mappings'] as Array<any>).map(ScimAttributeMappingConfigurationResourceFromJSON)),
    };
}

export function ScimAttributeMappingResourceToJSON(value?: ScimAttributeMappingResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'mappings': ((value['mappings'] as Array<any>).map((v) => ScimAttributeMappingConfigurationResourceToJSON(v))),
    };
}

